import T from 'prop-types';

export default {
  selectedDay: T.object,
  events: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      skill_dates: T.arrayOf(
        T.shape({
          id: T.number.isRequired,
          multiplicator: T.number,
          period: T.oneOf(['day', 'week', 'month', 'year']),
          start_date: T.string,
          stop_date: T.string
        })
      )
    })
  ),
  color: T.string,
  openModal: T.func.isRequired,
  showCalendar: T.func.isRequired,
  selectedMonthEvents: T.arrayOf(
    T.shape({
      title: T.string.isRequired,
      date: T.object
    })
  )
};



// WEBPACK FOOTER //
// ./src/shapes/events.js